export default __webpack_public_path__ + "a387f4706d7fc1260c32c5c071d817bd.png";